import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import HoverContainer from '@components/HoverContainer';
import TitleWithArrow from '@components/TitleWithArrow';
import BalanceChart from '@containers/BalanceChart';

import style from './WalletsOverview.scss';

const cn = bemCssModules(style, 'WalletsOverview');
const ti = getTestId('WalletsOverview');

export const WalletsOverview: CustomFC = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <HoverContainer link={CONST.nav.profileOverview}>
        <TitleWithArrow text={t('profile.wallets_overview')} />
        <BalanceChart className={cn('chart')} chartClass={cn('content')} onlyCurrencyForMobile />
      </HoverContainer>
    </div>
  );
};

export default WalletsOverview;
